import { useEffect, useState } from "react";

import {
    Box,
    Container,
    Paper,
    Typography,
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    IconButton,
    Divider,
    Stack,
    Chip
} from "@mui/material";
import {

    CalendarMonthOutlined,
    CloseRounded,
} from "@mui/icons-material";

import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";

import colegio from "../../assets/img/antilllen.png";

import { useComunidadDestacados } from "../../hooks/UseComunidad";
import { formatearFecha } from "../../utils/FormatoFecha";

const backendURL = process.env.REACT_APP_BACKEND_URL;


const coloresTipo = {

    importante: "#D32F2F",

    recordatorio: "#3DA65C",

    informativo: "#2F3F83",

  

};


// ======================================================
// NOMBRE VISIBLE DEL TIPO
// ======================================================

const nombresTipo = {

    importante: "IMPORTANTE",

    recordatorio: "RECORDATORIO",

    informativo: "INFORMATIVO",

   

};

export const HeroComunicado = () => {

    const {
        destacados,
        loading,
        error,
        cargarDestacados,
    } = useComunidadDestacados();
    const [
        comunicadoSeleccionado,
        setComunicadoSeleccionado,
    ] = useState(null);

    const [activo, setActivo] = useState(0);

    // ==================================================
    // ABRIR MODAL
    // ==================================================

    const handleOpenDialog = (item) => {

        setComunicadoSeleccionado(item);

    };


    // ==================================================
    // CERRAR MODAL
    // ==================================================

    const handleCloseDialog = () => {

        setComunicadoSeleccionado(null);

    };

    // =========================================
    // CARGAR DESTACADOS
    // =========================================

    useEffect(() => {

        cargarDestacados();

    }, []);


    // =========================================
    // REINICIAR SLIDE
    // =========================================

    useEffect(() => {

        if (activo >= destacados.length) {
            setActivo(0);
        }

    }, [destacados, activo]);


    // =========================================
    // AUTOMÁTICO
    // =========================================

    useEffect(() => {

        if (destacados.length <= 1) {
            return;
        }

        const intervalo = setInterval(() => {

            setActivo((prev) =>
                prev === destacados.length - 1
                    ? 0
                    : prev + 1
            );

        }, 6000);


        return () => clearInterval(intervalo);

    }, [destacados]);

    
    const obtenerColorTipo = (tipo) => {

        return (
            coloresTipo[
                tipo?.toLowerCase()
            ] || "#561C33"
        );

    };


    // ==================================================
    // OBTENER NOMBRE DEL TIPO
    // ==================================================

    const obtenerNombreTipo = (tipo) => {

        return (
            nombresTipo[
                tipo?.toLowerCase()
            ] ||
            tipo?.toUpperCase() ||
            "COMUNICADO"
        );

    };


    // ==================================================
    // OBTENER IMAGEN
    // ==================================================

    const obtenerImagen = (item) => {

        if (!item?.imagen) {

            return colegio;

        }

        return `${backendURL}/${item.imagen}`;

    };
    // =========================================
    // SIGUIENTE
    // =========================================

    const siguiente = () => {

        if (!destacados.length) return;

        setActivo((prev) =>
            prev === destacados.length - 1
                ? 0
                : prev + 1
        );

    };


    // =========================================
    // ANTERIOR
    // =========================================

    const anterior = () => {

        if (!destacados.length) return;

        setActivo((prev) =>
            prev === 0
                ? destacados.length - 1
                : prev - 1
        );

    };


    // =========================================
    // LOADING
    // =========================================

    if (loading) {

        return (

            <Container maxWidth="xl">

                <Paper
                    sx={{
                        minHeight: {
                            xs: 420,
                            md: 430,
                        },

                        borderRadius: "30px",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        background:
                            "linear-gradient(135deg,#171f56 0%, #232d74 100%)",
                    }}
                >

                    <CircularProgress
                        sx={{
                            color: "#fff",
                        }}
                    />

                </Paper>

            </Container>

        );

    }


    // =========================================
    // SIN DESTACADOS
    // =========================================

    if (!destacados.length) {

        return (

            <Container maxWidth="xl">

                <Paper
                    sx={{
                        minHeight: {
                            xs: 420,
                            md: 430,
                        },

                        borderRadius: "30px",

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        background:
                            "linear-gradient(135deg,#171f56 0%, #232d74 100%)",

                        color: "#fff",
                    }}
                >

                    <Typography
                        sx={{
                            fontSize: "1.2rem",
                            fontWeight: 600,
                        }}
                    >
                        No hay publicaciones destacadas.
                    </Typography>

                </Paper>

            </Container>

        );

    }


    // =========================================
    // DESTACADO ACTUAL
    // =========================================

    const item = destacados[activo];


    // =========================================
    // IMAGEN
    // =========================================

    const imagen = item.imagen
        ? `${backendURL}/${item.imagen}`
        : colegio;


    return (

        <Box>

            <Container maxWidth="xl">

                <Paper
                    sx={{
                        position: "relative",

                        overflow: "hidden",

                        borderRadius: "30px",

                        background:
                            "linear-gradient(135deg,#171f56 0%, #232d74 100%)",

                        height: {
                          xs: 520,
                          sm: 480,
                          md: 430,
                          lg: 430,
                          xl: 430,
                      },
                        display: "grid",

                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1.1fr",
                        },
                    }}
                >

                    {/* =================================
                        IMAGEN
                    ================================= */}

                    <Box
    component="img"
    src={imagen}
    alt={item.titulo}
    onError={(e) => {
        e.currentTarget.src = colegio;
    }}
    sx={{
        position: "absolute",

        top: 0,
        right: 0,
        bottom: 0,

        width: {
            xs: "100%",
            md: "55%",
        },

        height: "100%",

        objectFit: "cover",

        objectPosition: "center",

        WebkitMaskImage: {
            xs: "none",
            md: "linear-gradient(to left, black 72%, transparent 100%)",
        },

        maskImage: {
            xs: "none",
            md: "linear-gradient(to left, black 72%, transparent 100%)",
        },
    }}
/>


                    {/* =================================
                        DEGRADADO
                    ================================= */}

                    <Box
                        sx={{
                            position: "absolute",

                            inset: 0,

                            background:
                                "linear-gradient(90deg, rgba(23,31,86,1) 0%, rgba(35,45,116,.96) 40%, rgba(35,45,116,.45) 68%, rgba(35,45,116,.15) 100%)",

                            zIndex: 1,
                        }}
                    />


                    {/* =================================
                        CONTENIDO
                    ================================= */}

                    <Box
                        sx={{
                            position: "relative",

                            zIndex: 3,

                            p: {
                                xs: 4,
                                md: 7,
                            },

                            display: "flex",

                            flexDirection: "column",

                            justifyContent: "center",

                            color: "#fff",

                            maxWidth: {
                                xs: "100%",
                                md: "90%",
                            },
                        }}
                    >

                        {/* BADGE */}

                        <Box
                            sx={{
                                width: "fit-content",

                                bgcolor: "#c12559",

                                px: 2,

                                py: .6,

                                borderRadius: "40px",

                                fontWeight: 700,

                                fontSize: ".8rem",

                                mb: 3,

                                textTransform: "uppercase",
                            }}
                        >
                            DESTACADO
                        </Box>


                        {/* TIPO */}

                        <Typography
                            sx={{
                                fontSize: ".85rem",

                                fontWeight: 700,

                                textTransform: "uppercase",

                                letterSpacing: "1px",

                                opacity: .8,

                                mb: 1,
                            }}
                        >
                            {item.tipo}
                        </Typography>


                        {/* TITULO */}

                        <Typography
                            sx={{
                                fontWeight: 700,

                                lineHeight: 1.1,

                                fontSize: {
                                    xs: "1.8rem",
                                    md: "2.4rem",
                                },
                            }}
                        >
                            {item.titulo}
                        </Typography>


                        {/* FECHA */}

                        {item.fecha && (

                            <Typography
                                sx={{
                                    mt: 1.5,

                                    fontSize: ".85rem",

                                    fontWeight: 600,

                                    opacity: .75,
                                }}
                            >
                                {formatearFecha(item.fecha)}
                            </Typography>

                        )}


                        {/* DESCRIPCIÓN */}

                        {item.pie_portada && (

                            <Typography
                                sx={{
                                    mt: 1,

                                    opacity: .95,

                                    lineHeight: 1.7,

                                    fontSize: {
                                        xs: ".9rem",
                                        md: "1rem",
                                    },

                                    display: "-webkit-box",

                                    WebkitLineClamp: 3,

                                    WebkitBoxOrient: "vertical",

                                    overflow: "hidden",
                                }}
                            >
                                {item.pie_portada}
                            </Typography>

                        )}


                        {/* BOTÓN */}

                        <Button
                         onClick={() =>
                                                    handleOpenDialog(
                                                        item
                                                    )}
                            endIcon={
                                <ArrowForwardRoundedIcon />
                            }

                            variant="contained"

                            sx={{
                                mt: 4,

                                width: "fit-content",

                                bgcolor: "#fff",

                                color: "#484a75",

                                px: 4,

                                py: 1.5,

                                borderRadius: "15px",

                                textTransform: "none",

                                fontWeight: 700,

                                "&:hover": {
                                    bgcolor: "#f5f5f5",
                                },
                            }}
                        >
                            Leer más
                        </Button>

                    </Box>


                    {/* =================================
                        CONTROLES
                    ================================= */}

                    {destacados.length > 1 && (

                        <Box
                            sx={{
                                position: "absolute",

                                bottom: 30,

                                left: "50%",

                                transform:
                                    "translateX(-50%)",

                                display: "flex",

                                alignItems: "center",

                                gap: 1.5,

                                color: "#fff",

                                zIndex: 5,
                            }}
                        >

                            {/* ANTERIOR */}

                            <Button
                                onClick={anterior}
                                sx={{
                                    minWidth: 35,

                                    width: 35,

                                    height: 35,

                                    borderRadius: "50%",

                                    color: "#fff",

                                    bgcolor:
                                        "rgba(255,255,255,.12)",

                                    "&:hover": {
                                        bgcolor:
                                            "rgba(255,255,255,.25)",
                                    },
                                }}
                            >

                                <KeyboardArrowLeftRoundedIcon />

                            </Button>


                            {/* INDICADORES */}

                            {destacados.map(
                                (_, index) => (

                                    <Box
                                        key={index}
                                        onClick={() =>
                                            setActivo(index)
                                        }
                                        sx={{
                                            width:
                                                index === activo
                                                    ? 28
                                                    : 9,

                                            height: 9,

                                            borderRadius:
                                                "20px",

                                            bgcolor:
                                                index === activo
                                                    ? "#fff"
                                                    : "rgba(255,255,255,.45)",

                                            cursor:
                                                "pointer",

                                            transition:
                                                ".3s",
                                        }}
                                    />

                                )
                            )}


                            {/* SIGUIENTE */}

                            <Button
                                onClick={siguiente}
                                sx={{
                                    minWidth: 35,

                                    width: 35,

                                    height: 35,

                                    borderRadius: "50%",

                                    color: "#fff",

                                    bgcolor:
                                        "rgba(255,255,255,.12)",

                                    "&:hover": {
                                        bgcolor:
                                            "rgba(255,255,255,.25)",
                                    },
                                }}
                            >

                                <KeyboardArrowRightRoundedIcon />

                            </Button>

                        </Box>

                    )}

                </Paper>

            </Container>
                     <Dialog
                                    open={
                                        Boolean(
                                            comunicadoSeleccionado
                                        )
                                    }
                    
                                    onClose={
                                        handleCloseDialog
                                    }
                    
                                    fullWidth
                    
                                    maxWidth="md"
                    
                                    scroll="paper"
                    
                                    PaperProps={{
                                        sx: {
                    
                                            borderRadius: {
                                                xs: "18px",
                                                sm: "26px",
                                            },
                    
                                            overflow:
                                                "hidden",
                    
                                            width: {
                                                xs: "calc(100% - 20px)",
                                                sm: "90%",
                                            },
                    
                                            maxHeight: {
                                                xs: "92vh",
                                                md: "88vh",
                                            },
                                        },
                                    }}
                                >
                    
                                    {comunicadoSeleccionado && (
                    
                                        <>
                    
                                            {/* ==================================================
                                                IMAGEN
                                            ================================================== */}
                    
                                            <Box
                                                sx={{
                                                    position:
                                                        "relative",
                    
                                                    height: {
                                                        xs: "100%",
                                                        sm: "100%",
                                                        md: "100%",
                                                    },
                    
                                                    overflow:
                                                        "hidden",
                                                }}
                                            >
                    
                                                <Box
                                                    component="img"
                    
                                                    src={
                                                        obtenerImagen(
                                                            comunicadoSeleccionado
                                                        )
                                                    }
                    
                                                    alt={
                                                        comunicadoSeleccionado.titulo
                                                    }
                    
                                                    onError={(
                                                        event
                                                    ) => {
                    
                                                        event.currentTarget.src =
                                                            colegio;
                    
                                                    }}
                    
                                                    sx={{
                                                        width:
                                                            "100%",
                    
                                                        height:
                                                            "100%",
                    
                                                        objectFit:
                                                            "cover",
                                                    }}
                                                />
                    
                    
                                                {/* DEGRADADO */}
                    
                                                <Box
                                                    sx={{
                                                        position:
                                                            "absolute",
                    
                                                        inset: 0,
                    
                                                        background:
                                                            "linear-gradient(180deg, rgba(0,0,0,.05) 30%, rgba(0,0,0,.75) 100%)",
                                                    }}
                                                />
                    
                    
                                                {/* TIPO */}
                    
                                                <Chip
                                                    label={
                                                        obtenerNombreTipo(
                                                            comunicadoSeleccionado.tipo
                                                        )
                                                    }
                    
                                                    sx={{
                                                        position:
                                                            "absolute",
                    
                                                        top: {
                                                            xs: 15,
                                                            sm: 20,
                                                        },
                    
                                                        left: {
                                                            xs: 15,
                                                            sm: 25,
                                                        },
                    
                                                        bgcolor:
                                                            obtenerColorTipo(
                                                                comunicadoSeleccionado.tipo
                                                            ),
                    
                                                        color:
                                                            "#fff",
                    
                                                        fontWeight:
                                                            700,
                    
                                                        textTransform:
                                                            "uppercase",
                                                    }}
                                                />
                    
                    
                                                {/* CERRAR */}
                    
                                                <IconButton
                                                    onClick={
                                                        handleCloseDialog
                                                    }
                    
                                                    sx={{
                                                        position:
                                                            "absolute",
                    
                                                        top: {
                                                            xs: 10,
                                                            sm: 15,
                                                        },
                    
                                                        right: {
                                                            xs: 10,
                                                            sm: 15,
                                                        },
                    
                                                        bgcolor:
                                                            "rgba(0,0,0,.35)",
                    
                                                        color:
                                                            "#fff",
                    
                                                        "&:hover":
                                                            {
                                                                bgcolor:
                                                                    "rgba(0,0,0,.55)",
                                                            },
                                                    }}
                                                >
                    
                                                    <CloseRounded />
                    
                                                </IconButton>
                    
                    
                                                {/* TÍTULO */}
                    
                                               
                    
                                            </Box>
                    
                    
                                            {/* ==================================================
                                                CONTENIDO
                                            ================================================== */}
                    
                                            <DialogContent
                                                sx={{
                                                    p: {
                                                        xs: 3,
                                                        sm: 4,
                                                        md: 5,
                                                    },
                                                }}
                                            >
                    
                                                {/* FECHA */}
                    
                                                {comunicadoSeleccionado.fecha && (
                    
                                                    <Stack
                                                        direction="row"
                                                        spacing={1}
                                                        alignItems="center"
                                                        mb={3}
                                                    >
                    
                                                        <CalendarMonthOutlined
                                                            sx={{
                                                                color:
                                                                    obtenerColorTipo(
                                                                        comunicadoSeleccionado.tipo
                                                                    ),
                    
                                                                fontSize:
                                                                    22,
                                                            }}
                                                        />
                    
                                                        <Typography
                                                            sx={{
                                                                color:
                                                                    "#777",
                    
                                                                fontSize:
                                                                    {
                                                                        xs: ".85rem",
                                                                        sm: ".95rem",
                                                                    },
                                                            }}
                                                        >
                                                            {
                                                                formatearFecha(
                                                                    comunicadoSeleccionado.fecha
                                                                )
                                                            }
                                                        </Typography>
                    
                                                    </Stack>
                    
                                                )}
                    
                    
                                                <Divider
                                                    sx={{
                                                        mb: 3,
                                                    }}
                                                />
                    
                    
                                                {/* TÍTULO */}
                    
                                                <Typography
                                                    sx={{
                                                        color:
                                                            "#561C33",
                    
                                                        fontWeight:
                                                            700,
                    
                                                        fontSize:
                                                            {
                                                                xs: "1.2rem",
                                                                sm: "1.5rem",
                                                            },
                    
                                                        mb: 2,
                                                    }}
                                                >
                                                   { comunicadoSeleccionado.titulo}
                                                </Typography>
                    
                    
                                                {/* DESCRIPCIÓN */}
                    
                                                <Typography
                                                    sx={{
                                                        color:
                                                            "#666",
                    
                                                        lineHeight:
                                                            1.9,
                    
                                                        fontSize:
                                                            {
                                                                xs: ".9rem",
                                                                sm: "1rem",
                                                                md: "1.05rem",
                                                            },
                    
                                                        whiteSpace:
                                                            "pre-line",
                                                    }}
                                                >
                                                    {
                                                        comunicadoSeleccionado.contenido ||
                                                        comunicadoSeleccionado.pie_portada ||
                                                        "No hay información disponible."
                                                    }
                                                </Typography>
                    
                                            </DialogContent>
                    
                                        </>
                    
                                    )}
                    
                                </Dialog>
        </Box>

    );
};